import slotTypesConfig from './slot-types-config.json';
export default function getSlotTypes(sportId, outcomeType) {
    try {
        var slotTypes = slotTypesConfig[sportId][outcomeType];
        if (slotTypes === undefined) {
            console.warn("Cannot find slot types for sport#".concat(sportId, ", outcome#").concat(outcomeType));
        }
        return slotTypes[0] || outcomeType;
    }
    catch (e) {
        console.log("Cant find slot type for sport#".concat(sportId, ", outcome#").concat(outcomeType, ":"), e);
    }
    return [outcomeType];
}



// WEBPACK FOOTER //
// ./src/components/grid/providers/SlotTypeProvider.js